/* index.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._p12f1kdj%7Bmax-width%3A25pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._c71l1x4w%7Bmax-height%3A476px%7D");
import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package

import { Stack as CompiledStack } from '@atlaskit/primitives/compiled/stack';
import { FlyoutMenuItem, FlyoutMenuItemContent, FlyoutMenuItemTrigger } from '@atlaskit/side-nav-items/flyout-menu-item';
import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';
import { AnalyticsSideNavItem, useSendSideNavItemClick } from '@townsquare/analytics-nav4';
import { useAppsByProduct } from '@townsquare/apps-store/hooks';
import { APP_ITEM_ID_TO_WORKLENS, SideNavAppItem as SideNavAppItemID } from '@townsquare/navigation-config/nav4';
import { useRouter } from '@townsquare/router/useRouter';
import type { CommonSideNavItemProps } from '../../../types';
const compiledFlyoutStyles = {
  root: "_p12f1kdj _c71l1x4w"
};

/**
 * This component handles rendering any app item in the customizable sidebar.
 *
 * It gets most of its configuration and data from `item`, e.g. the name and Icon.
 *
 * `products` is passed in with a list of product instances, to determine if the item should be hidden, individual, or a flyout menu.
 */
export const SideNavAppItem = (props: CommonSideNavItemProps): React.JSX.Element | null => {
  const {
    elemAfter,
    item
  } = props;
  const [routerStore] = useRouter();
  const sendSideNavItemClick = useSendSideNavItemClick();
  const worklensAppId = APP_ITEM_ID_TO_WORKLENS[(item.id as SideNavAppItemID)];
  const products = useAppsByProduct()[worklensAppId];
  if (!products || products.length === 0) {
    return null;
  }
  if (products.length === 1) {
    return <LinkMenuItem elemBefore={<item.Icon label="" />} elemAfter={elemAfter} href={products[0].url} target="_self" onClick={() => {
      sendSideNavItemClick('navigationItem', AnalyticsSideNavItem.VIEW_ALL_APPS, {
        screen: routerStore.route.name,
        componentType: 'customItem',
        itemType: 'product',
        itemId: item.analyticsSubject
      });
    }}>
				{products[0].productName || item.name}
			</LinkMenuItem>;
  }
  return <FlyoutMenuItem>
			<FlyoutMenuItemTrigger elemBefore={<item.Icon label="" />} onClick={() => {
      // `button` actionSubject because this is just opening the flyout, not navigating anywhere.
      sendSideNavItemClick('button', AnalyticsSideNavItem.VIEW_ALL_APPS, {
        screen: routerStore.route.name,
        componentType: 'customItem',
        itemType: 'product',
        itemId: item.analyticsSubject
      });
    }}>
				{item.name}
			</FlyoutMenuItemTrigger>
			<FlyoutMenuItemContent>
				<CompiledStack xcss={compiledFlyoutStyles.root}>
					{products.map(product => <LinkMenuItem key={product.siteName} href={product.url} elemBefore={<item.Icon label="" />} onClick={() => {
          sendSideNavItemClick('navigationItem', AnalyticsSideNavItem.VIEW_ALL_APPS, {
            screen: routerStore.route.name,
            componentType: 'customItem',
            itemType: 'product',
            itemId: item.analyticsSubject
          });
        }}>
							{product.siteName}
						</LinkMenuItem>)}
				</CompiledStack>
			</FlyoutMenuItemContent>
		</FlyoutMenuItem>;
};